import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="legal-hero-overlay"></div>
        <div className="legal-hero-content">
          <h1>Terms & Conditions</h1>
          <p>Last Updated: January 6, 2026</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            
            <h2>1. Agreement to Terms</h2>
            <p>
              These Terms and Conditions ("Terms") constitute a legally binding agreement between you and F&H Audio 
              Solutions LLP ("Company," "we," "us," or "our") concerning your access to and use of our website, 
              products, and services.
            </p>
            <p>
              By accessing our website or engaging our services, you agree to be bound by these Terms. If you disagree 
              with any part of these Terms, you must not use our website or services.
            </p>

            <h2>2. Services</h2>
            <h3>2.1 Scope of Services</h3>
            <p>F&H Audio Solutions LLP provides:</p>
            <ul>
              <li>Professional audio-visual system design and installation</li>
              <li>Home theater and Hi-Fi audio solutions</li>
              <li>PA system design and installation</li>
              <li>Acoustic consultation and treatment</li>
              <li>Home automation integration</li>
              <li>Training and technical support services</li>
              <li>Premium audio equipment sales</li>
            </ul>

            <h3>2.2 Service Delivery</h3>
            <p>
              All services are subject to availability and provided on an appointment basis. Service timelines and 
              delivery schedules will be agreed upon in writing with each client.
            </p>

            <h2>3. Consultation and Site Visits</h2>
            <h3>3.1 Appointments</h3>
            <p>
              Site visits and consultations are by appointment only. Clients must schedule appointments in advance 
              and provide accurate information about their requirements and site conditions.
            </p>

            <h3>3.2 Consultation Fees</h3>
            <p>
              Initial consultation may be subject to fees, which will be communicated at the time of booking. 
              Consultation fees may be adjusted against project costs upon service engagement.
            </p>

            <h2>4. Quotations and Pricing</h2>
            <h3>4.1 Quotation Validity</h3>
            <p>
              All quotations are valid for 30 days from the date of issue unless otherwise specified. Prices are 
              subject to change based on market conditions, currency fluctuations, and product availability.
            </p>

            <h3>4.2 Pricing</h3>
            <ul>
              <li>All prices are in Indian Rupees (INR) unless otherwise stated</li>
              <li>Prices include applicable taxes (GST) unless mentioned as exclusive</li>
              <li>Installation, delivery, and additional services may be charged separately</li>
              <li>Custom projects are priced based on scope and requirements</li>
            </ul>

            <h2>5. Payment Terms</h2>
            <h3>5.1 Payment Schedule</h3>
            <p>Standard payment terms unless otherwise agreed:</p>
            <ul>
              <li>30% advance payment upon order confirmation</li>
              <li>40% payment before installation/delivery</li>
              <li>30% payment upon project completion and handover</li>
            </ul>

            <h3>5.2 Payment Methods</h3>
            <p>We accept payments via:</p>
            <ul>
              <li>Bank transfer (NEFT/RTGS/IMPS)</li>
              <li>Cheque (subject to clearance)</li>
              <li>UPI and digital payment methods</li>
              <li>Cash (subject to applicable limits)</li>
            </ul>

            <h3>5.3 Late Payments</h3>
            <p>
              Failure to make payments as per agreed schedule may result in project delays or suspension of services. 
              Interest may be charged on overdue amounts at the rate of 2% per month.
            </p>

            <h2>6. Orders and Cancellations</h2>
            <h3>6.1 Order Processing</h3>
            <p>
              Orders are confirmed upon receipt of advance payment and signed agreement. Processing time varies based 
              on product availability and project scope.
            </p>

            <h3>6.2 Cancellation Policy</h3>
            <ul>
              <li>Cancellations made within 48 hours of order confirmation: Full refund minus processing fees</li>
              <li>Cancellations after product order placement: Subject to 20% cancellation charges</li>
              <li>Cancellations after custom product manufacturing: No refund</li>
              <li>Service cancellations: As per service agreement terms</li>
            </ul>

            <h2>7. Installation and Setup</h2>
            <h3>7.1 Site Requirements</h3>
            <p>Clients must ensure:</p>
            <ul>
              <li>Adequate access to installation sites</li>
              <li>Availability of electrical and structural requirements as specified</li>
              <li>Compliance with building codes and regulations</li>
              <li>Proper environmental conditions for equipment installation</li>
            </ul>

            <h3>7.2 Installation Timeline</h3>
            <p>
              Installation schedules are estimates and may be subject to delays due to site conditions, product 
              availability, or unforeseen circumstances. We will make reasonable efforts to adhere to agreed timelines.
            </p>

            <h2>8. Warranties and Guarantees</h2>
            <h3>8.1 Product Warranties</h3>
            <ul>
              <li>All products carry manufacturer's warranty as specified</li>
              <li>Warranty terms vary by brand and product category</li>
              <li>Warranty claims must be made through proper channels with valid documentation</li>
              <li>Warranty does not cover damage from misuse, accidents, or unauthorized modifications</li>
            </ul>

            <h3>8.2 Installation Warranty</h3>
            <p>
              We provide a 12-month warranty on our installation workmanship from the date of project completion. 
              This covers defects arising from our installation work but excludes product defects.
            </p>

            <h3>8.3 Warranty Exclusions</h3>
            <p>Warranties do not cover:</p>
            <ul>
              <li>Normal wear and tear</li>
              <li>Damage from improper use or maintenance</li>
              <li>Unauthorized repairs or modifications</li>
              <li>Environmental damage (water, lightning, power surges)</li>
              <li>Commercial use of residential products</li>
            </ul>

            <h2>9. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, F&H Audio Solutions LLP shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages arising from:
            </p>
            <ul>
              <li>Use or inability to use our products or services</li>
              <li>Unauthorized access to or alteration of your data</li>
              <li>Third-party actions or products</li>
              <li>Delays or interruptions in service</li>
            </ul>
            <p>
              Our total liability shall not exceed the amount paid by you for the specific product or service giving 
              rise to the claim.
            </p>

            <h2>10. Intellectual Property</h2>
            <p>
              All content on our website, including designs, logos, text, graphics, and software, is the property of 
              F&H Audio Solutions LLP or our licensors and is protected by Indian and international copyright laws.
            </p>
            <p>
              Custom designs and installation plans created for clients remain our intellectual property unless 
              explicitly transferred in writing.
            </p>

            <h2>11. Confidentiality</h2>
            <p>
              We maintain strict confidentiality regarding client projects, designs, and personal information. We 
              may showcase completed projects with client permission for marketing purposes.
            </p>

            <h2>12. Force Majeure</h2>
            <p>
              We shall not be liable for delays or failures in performance resulting from acts beyond our reasonable 
              control, including but not limited to:
            </p>
            <ul>
              <li>Natural disasters, pandemics, or acts of God</li>
              <li>Government actions, regulations, or restrictions</li>
              <li>War, terrorism, or civil unrest</li>
              <li>Labor strikes or disputes</li>
              <li>Supply chain disruptions</li>
              <li>Power failures or telecommunications outages</li>
            </ul>

            <h2>13. Dispute Resolution</h2>
            <h3>13.1 Governing Law</h3>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India, without regard 
              to conflict of law principles.
            </p>

            <h3>13.2 Jurisdiction</h3>
            <p>
              Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts 
              in Guntur, Andhra Pradesh, India.
            </p>

            <h3>13.3 Arbitration</h3>
            <p>
              Parties agree to attempt resolution of disputes through good faith negotiation. If unresolved, 
              disputes may be referred to arbitration in accordance with the Arbitration and Conciliation Act, 1996.
            </p>

            <h2>14. Customer Obligations</h2>
            <p>Clients agree to:</p>
            <ul>
              <li>Provide accurate information and requirements</li>
              <li>Make timely payments as per agreed schedule</li>
              <li>Grant necessary access for installation and service</li>
              <li>Maintain equipment as per manufacturer recommendations</li>
              <li>Notify us promptly of any issues or concerns</li>
              <li>Use products and services in accordance with guidelines</li>
            </ul>

            <h2>15. Modifications to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon 
              posting on our website. Continued use of our services after changes constitutes acceptance of modified Terms.
            </p>

            <h2>16. Severability</h2>
            <p>
              If any provision of these Terms is found to be unenforceable or invalid, that provision shall be 
              limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in 
              full force and effect.
            </p>

            <h2>17. Contact Information</h2>
            <p>For questions regarding these Terms and Conditions, please contact:</p>
            <div className="contact-details">
              <p><strong>F&H Audio Solutions LLP</strong></p>
              <p>16-2A, 1st Floor, Kannavarithota</p>
              <p>Guntur, Andhra Pradesh - 522001</p>
              <p>India</p>
              <p>Email: <a href="mailto:info@fhaudio.in">info@fhaudio.in</a></p>
              <p>Phone: <a href="tel:+919876543210">+91 98765 43210</a></p>
              <p>GST No.: [To be provided]</p>
            </div>

            <div className="legal-footer">
              <p>
                By engaging our services or making a purchase, you acknowledge that you have read, understood, and 
                agree to be bound by these Terms and Conditions.
              </p>
              <Link to="/" className="btn btn-primary">Back to Home</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
